export const headerNames = {
  memberTools: 'Member Tools',
  documentation: 'Documentation',
  hqAccess: 'HQ Access',
  siteAdministration: 'Site Administration',
  system: 'System',
  salesAdministration: 'Sales Administration',
};
